import React, { useState, useEffect } from 'react';
import Header from './header';
import SideBar from './side-bar';
import Chat from '../chat';
import { Container, BoxSideBar, BoxContent, CustomMain, MobileOverlay } from './styles';

const Layout = ({ children }) => {
  // Carrega o estado inicial do sidebar do localStorage
  const getInitialSidebarState = () => {
    try {
      const savedState = localStorage.getItem('sidebarCollapsed');
      return savedState ? JSON.parse(savedState) : false;
    } catch (error) {
      console.error('Erro ao carregar estado do sidebar do localStorage:', error);
      return false;
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(getInitialSidebarState);
  const [isMobile, setIsMobile] = useState(false);

  // Salva o estado do sidebar no localStorage sempre que ele mudar
  useEffect(() => {
    try {
      localStorage.setItem('sidebarCollapsed', JSON.stringify(isCollapsed));
    } catch (error) {
      console.error('Erro ao salvar estado do sidebar no localStorage:', error);
    }
  }, [isCollapsed]);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Se for mobile, garantir que o sidebar comece expandido
      if (mobile && isCollapsed) {
        setIsCollapsed(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleOverlayClick = () => {
    if (!isCollapsed) {
      setIsCollapsed(true);
    }
  };

  return (
    <Container id='layout-container'>
      <BoxSideBar id='sidebar-box' className={isCollapsed ? 'collapsed' : ''}>
        <SideBar id='sidebar-component' isCollapsed={isCollapsed} toggleSidebar={toggleSidebar}/>
      </BoxSideBar>
      
      <MobileOverlay isCollapsed={isCollapsed} onClick={handleOverlayClick} />
      
      <BoxContent id='content-box' className={isCollapsed ? 'collapsed' : ''}>
        <Header id='header-component' isCollapsed={isCollapsed} toggleSidebar={toggleSidebar}/>
        <CustomMain id='main-component'>
        {React.cloneElement(children, { isCollapsed })}
        </CustomMain>
      </BoxContent>
      
      {/* Chat posicionado no lado direito */}
      <Chat id='chat' />
    </Container>
  );
};

export default Layout;
